<template>
  <div>
    <div class="content">
      <div class="content-add-detail">
        <el-form :model="queryParams" class="demo-form-inline" :label-position="labelPosition">
          <div class="add-basic-information">
            <div class="add-title">
              <span class="basic title-font-style">备货信息</span>
            </div>
            <div
              class="add-content details-line-height"
              style="padding-left:50px;padding-bottom:10px"
             >
              <el-row>
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="备货编号：">
                      <span>{{ queryParams.stockupCode || '--'}}</span>
                    </el-form-item>
                  </el-col>
                </el-col>
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="备货方式：">
                      <span>
                        {{
                        queryParams.distributionType === 1
                        ? "仓储备货"
                        : "调拨备货" || '--'
                        }}
                      </span>
                    </el-form-item>
                  </el-col>
                </el-col>
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="预计发货时间：">
                      <span>{{queryParams.deliveryTime | dateFilterD}}</span>
                    </el-form-item>
                  </el-col>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="备货仓库：">
                      {{
                      queryParams.storageName || '--'
                      }}
                    </el-form-item>
                  </el-col>
                </el-col>
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="联系电话：">
                      {{
                      queryParams.storagePhone || '--'
                      }}
                    </el-form-item>
                  </el-col>
                </el-col>
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="仓库地址：">
                      {{
                      queryParams.storageAddress ||'--'
                      }}
                    </el-form-item>
                  </el-col>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="发起人：">
                      {{
                      queryParams.createUser ||'--'
                      }}
                    </el-form-item>
                  </el-col>
                </el-col>
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="请求备货时间：">
                      {{
                      queryParams.createDate | dateFilter
                      }}
                    </el-form-item>
                  </el-col>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="add-basic-information">
            <div class="add-title add-title1" style="padding-left:20px;padding-top:20px">
              <div>
                <span class="basic title-font-style">
                  {{
                  this.$route.query.processState === 3
                  ? "备货产品详情"
                  : "锁库产品清单"
                  }}
                </span>
              </div>
              <span style="text-align:right;padding-right:20px;">
                <el-button plain @click="toExport">导出备货单</el-button>
              </span>
            </div>
            <div class="box-table" style="padding-bottom:30px;">
              <el-table
                max-height="378"
                v-if="stockupState === 2"
                :row-class-name="isCheck"
                border
                ref="tableRef"
                tooltip-effect="dark"
                :data="list"
                :header-cell-style="tableHeader"
                v-loading="loadingTable"
                element-loading-text="拼命加载中请稍后..."
                element-loading-spinner="el-icon-loading"
               >
                <el-table-column label="品牌" prop="brandName" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{scope.row.brandName || '--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="产品名称" prop="proName" width="120px" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{scope.row.proName || '--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="型号" width="100px" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div
                      class="approval line-limit-length"
                      @click="detailModel(scope.row)"
                    >{{ scope.row.proModel || '--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="订货号" prop="proOrdernum" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{ scope.row.proOrdernum || '--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="单位">
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{ scope.row.proUnit || '--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="货架" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{ scope.row.shelvesName ||'--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="备货数量" v-if="stockupState === 2">
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{ String(scope.row.stockupCount) ||'--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="货架库存量" width="120" v-if="stockupState === 2">
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{ String(scope.row.counts) ||'--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="历史已锁库" width="120" v-if="stockupState === 2">
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{ String(scope.row.lockCounts) ||'--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="入库批次" width="100" v-if="stockupState === 2" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{ scope.row.warehouseBatchCode || '--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column :label="'本次锁库数量'" width="120" v-if="stockupState === 2">
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{ String(scope.row.lockCount) ||'--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="实际库存量" width="120" v-if="stockupState === 2">
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{ String(scope.row.count) ||'--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column :label="'本次锁库数量'" width="130" v-if="stockupState === 3">
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{String(scope.row.lockCount) ||'--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="货架库存量" width="130" v-if="stockupState === 3">
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{ String(scope.row.counts) ||'--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="历史已锁库" width="120" v-if="stockupState === 3">
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{ String(scope.row.lockCounts) ||'--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="入库批次" width="170px" v-if="stockupState === 3" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{ scope.row.warehouseBatchCode ||'--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="备注" show-overflow-tooltip v-if="stockupState === 3">
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{ scope.row.mark || '--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" v-if="stockupState === 2">
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      @click="toVacancy(scope.row)"
                      v-show="scope.row.isLack&& scope.row.isCheck"
                    >报缺</el-button>
                    <el-button
                      type="text"
                      @click="toVacancy(scope.row)"
                      v-show="!scope.row.isLack"
                    >查看</el-button>
                    <el-button
                      type="text"
                      @click="colorVacancy(scope.$index,scope.row)"
                      v-show="scope.row.isLack && !scope.row.isCheck"
                    >报缺</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-table
               max-height="378"
                v-if="stockupState !== 2"
                border
                ref="tableRef"
                tooltip-effect="dark"
                :data="list"
                :header-cell-style="tableHeader"
                v-loading="loadingTable"
                element-loading-text="拼命加载中请稍后..."
                element-loading-spinner="el-icon-loading"
               >
                <el-table-column label="品牌" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{ scope.row.brandName ||'--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="产品名称" width="200px" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{ scope.row.proName ||'--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="型号" width="200px" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div
                      class="approval line-limit-length"
                      @click="detailModel(scope.row)"
                    >{{ scope.row.proModel ||'--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="订货号" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{ scope.row.proOrdernum ||'--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="单位">
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{ scope.row.proUnit ||'--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="货架" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{ scope.row.shelvesName ||'--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="备货数量" v-if="stockupState === 2">
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{ String(scope.row.stockupCount) ||'--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="货架库存量" width="120" v-if="stockupState === 2">
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{ String(scope.row.counts) ||'--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="历史已锁库" width="120" v-if="stockupState === 2">
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{ String(scope.row.lockCounts) ||'--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="入库批次" width="100px" v-if="stockupState === 2"  show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{ scope.row.warehouseBatchCode ||'--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column :label="'本次锁库数量'" width="120px;" v-if="stockupState === 2">
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{ String(scope.row.lockCount) ||'--' }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="实际库存量" v-if="stockupState === 2">
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{ String(scope.row.count) ||'--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column :label="'本次锁库数量'" v-if="stockupState === 3">
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{ String(scope.row.lockCount) ||'--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="货架库存量" v-if="stockupState === 3">
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{ String(scope.row.counts) ||'--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="历史已锁库" v-if="stockupState === 3">
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{ String(scope.row.lockCounts) ||'--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="入库批次" width="170px" v-if="stockupState === 3" show-overflow-tooltip>
                  <template slot-scope="scope" show-overflow-tooltip>
                    <div class="line-limit-length">{{ scope.row.warehouseBatchCode ||'--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="备注" show-overflow-tooltip v-if="stockupState === 3">
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{ scope.row.mark ||'--'}}</div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div
              class="add-basic-information"
              v-if="distributionType===1 && stockupState===2"
              style="padding:14px 0 0px 20px;margin-top:0px;"
            >
              <div
                style="font-size:12px;color:#D35E5E;"
              >*备货及发货过程中如发现缺失，可点击报缺按钮，修改备货方案并提交报缺。产品清单中标红产品所在货架正存在盘点任务，不允许发起报缺。</div>
              <div
                style="font-size:12px;margin-bottom:14px;color:#D35E5E;"
              >如货架产品存在报缺，且影响备货，可等待盘点任务结束后进行备货，如不影响备货可直接确认备货</div>
              <el-button type="primary" @click="onSureStock" style="margin-bottom:30px">
                {{
                distributionType === 1 ? "确认备货" : "确认发货"
                }}
              </el-button>
            </div>
          </div>
        </el-form>

        <!-------------- 备货确认提示框 ------------------->
        <sure-stock-tip ref="sureStockTipRefs"></sure-stock-tip>
        <!-------------- 报缺方案提交信息侧边栏 ------------>
        <submission-of-vacancis ref="sureStockTipsRefs" @getList="getListRef"></submission-of-vacancis>
        <!-- ------------ 存在盘点无法报缺----------------->
        <el-dialog :visible.sync="checkDialog" class="dialog-address" width="437px" title="提示">
          <div class="dialog-tip" style="padding-left:30px;">该产品所在货架存在盘点任务不允许发起报缺.</div>
          <span slot="footer" class="dialog-center">
            <el-button @click="checkDialog=false" type="primary">确定</el-button>
            <el-button @click="checkDialog=false">取消</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import sureStockTip from '../dialog/sureStockTip'
import stockProcessSlier from '../slideBar/stockProcessSlier'
import { queryStockupContent } from '@/api/storage/storage'
import { formatDate, downLoadFileBlob } from '@/util/tool'
import { addStorageStockCoeDerive } from '@/api/purchase/purchaseManage'

export default {
  components: {
    'sure-stock-tip': sureStockTip,
    'submission-of-vacancis': stockProcessSlier
  },
  data () {
    return {
      checkDialog: false,
      labelPosition: 'left',
      list: [], // 备货列表
      queryParams: {}, // 表单数据
      pitchOnPpId: [],
      loadingTable: false,
      isUpdate: false,
      mark: '', // 中通备注
      distributionType: '2', // 备货方式 1仓库备货 2调拨备货
      stockupState: '' // 备货状态 1待认领 2待处理 3已处理 4未揽件
    }
  },
  mounted () {
    this.queryStockupContent()
    this.distributionType = Number(this.$route.query.distributionType)
    this.stockupState = Number(this.$route.query.stockupState)
  },
  beforeRouteLeave: (to, from, next) => {
    if (to.name === 'stockMigrationList' && from.name === 'stockDetails') {
      next('/storage/storageManage/inventoryStockList')
    } else {
      next()
    }
  },
  methods: {
    // 判断盘点和保存情况
    isCheck ({ row, rowIndex }) {
      if (row.isLack === true && row.isCheck === false) {
        return 'warning-row'
      }
    },
    // 确认备货
    onSureStock () {
      this.dialogVisible = true
      if (this.distributionType === 1) {
        var stockDetailList = []
        stockDetailList = this.list
        this.$refs.sureStockTipRefs.onInitialize(
          stockDetailList,
          1,
          this.$route.query.id,
          this.$route.query.ocssIds
        )
      } else {
        // 确认调拨
        const params = {
          storageStockupContentVoList: this.list, // 备货产品清单集合
          // storageLogisticsVoList: this.formInline.gameArea, // 物流信息
          deliverType: this.deliverType, // 调拨方式
          expressCompany: this.expressCompany, // 快递公司
          ocsId: this.$route.query.id, // 备货清单id
          sbId: this.queryParams.sbId, // 仓库id
          arrivalTime: '', // 预计到达日期
          mark: this.mark // 发货说明
          // orderType: this.orderType, // 下单模式
          // transportType: this.transportType // 运输方式
        }
        this.$refs.sureStockTipRefs.onInitialize(
          params,
          2,
          this.$route.query.id,
          this.$route.query.ocssIds
        )
      }
    },
    // 循环添加form 表单
    toAddLogistic (list) {
      list.push({})
    },
    // 删除form表单中某一条
    toDelLogistic (list, index) {
      list.splice(index, 1)
    },
    // 根据备货产品id和备货方式distributionType 仓库方案id ocssIds 获取备货详情
    queryStockupContent () {
      queryStockupContent(
        this.$route.query.ocssIds,
        this.$route.query.id,
        this.$route.query.distributionType
      )
        .then(res => {
          if (res.data.code === 200) {
            this.queryParams = res.data.obj.storageStockupVo // 基本信息
            this.list = res.data.obj.storageStockupContentVoList // 备货产品详情
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 跳产品详情页
    detailModel (row) {
      this.$router.push({
        path: '/product/productManage/productDetails',
        query: { id: row.proId }
      })
    },
    toExport () {
      const params = {}
      params.distributionType = this.$route.query.distributionType
      params.ocssIds = this.$route.query.ocssIds
      params.ocsId = this.$route.query.id
      if (this.$route.query.distributionType === 1) {
        params.stockUrl = this.$store.state.optionsListGuidwarse
      } else {
        params.stockUrl = this.$store.state.optionsListGuid
      }

      addStorageStockCoeDerive(params)
        .then(res => {
          downLoadFileBlob(this, res)
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 报缺/查看
    toVacancy (row) {
      const obj = JSON.parse(JSON.stringify(row))
      this.$refs.sureStockTipsRefs.onInitialize(obj)
      // this.$refs.sureStockTipsRefs.onInitialize(row)
    },
    // 存在盘点无法报缺
    colorVacancy ($index, row) {
      this.checkDialog = true
    },
    // 报缺返回
    getListRef () {
      this.queryStockupContent()
      this.distributionType = Number(this.$route.query.distributionType)
      this.stockupState = Number(this.$route.query.stockupState)
    },
    // 设置头部颜色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    }
  },
  filters: {
    dateFilter
  }
}
function dateFilter (time) {
  const date = new Date(time)
  return formatDate(date, 'yyyy-MM-dd hh:mm')
}
</script>
<style lang="scss" scoped>
.span_row {
  display: flex;
  span {
    width: 94px;
  }
}
.add-basic-information .bottom {
  padding: 0 30px 30px 30px;
}
.add-basic-information .bottom-tip {
  margin: 15px 0;
}
.add-title1 {
  display: flex;
  justify-content: space-between;
  padding: 30px 0 0 20px;
}
.logistics-information {
  font-size: 16px;
  font-weight: bold;
  color: #4e555b;
  margin-bottom: 10px;
}
.el-table th,
.el-table tr {
  background-color: rgba(0, 0, 0, 1);
}
.el-button+.el-button {
  margin-left: 0 !important;
}
</style>
